var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.699,
    height: 161.699,
    viewBox: "0 0 161.699 161.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M93.694,19.708l-6.841-7.035a1.471,1.471,0,0,0-1.088-.466h0a1.411,1.411,0,0,0-1.088.466L37.255,60.444,20,43.186a1.5,1.5,0,0,0-2.177,0L10.9,50.1a1.549,1.549,0,0,0,0,2.216L32.668,74.087A6.884,6.884,0,0,0,37.216,76.3a7.213,7.213,0,0,0,4.509-2.138h.039L93.733,21.924A1.662,1.662,0,0,0,93.694,19.708Z",
    transform: "translate(31.966 39.989)",
    fill: "#30d500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M84.224,14.259a69.977,69.977,0,0,1,49.481,119.447A69.977,69.977,0,0,1,34.743,34.743,69.5,69.5,0,0,1,84.224,14.259m0-10.884a80.849,80.849,0,1,0,80.849,80.849A80.837,80.837,0,0,0,84.224,3.375Z",
    fill: "#30d500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.c1fc6a945022fb2a3b683351abc716f6.svg";
export { ForwardRef as ReactComponent };